<template>
  <router-link :to="goBack||to">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    to: {
      type: [Object , String]
    }
  },
  computed: {
    goBack() {
        return this.$route?.params?.goBack
    }
  },
};
</script>

<style lang="scss" scoped></style>
